export class feedbackModel {
    name: string = "";
    rating: number = 0;
    email: string = "";
    message: string = null;
    has_consented: boolean = false;
    recaptcha: string = "";
    country_id: number = null
}

export class FeedbackData {
    sr_no: number;
    id: number;
    rating: number;
    name: string;
    email: string;
    message: string;
    has_consented: boolean;
    is_featured: boolean;
    created_at: string;
    selected: boolean;
    country: {
        country_name: string;
    };
    source: string;
}

export class feedbackUpdateModel {
    review_id: number[];
    is_featured: boolean;
}

export class FeaturedFeedbackData {
    name: string;
    rating: number;
    message: string;
    // created_at: string;
}

export enum url_testimonials_source {
    covid = 'covid',
    free_counseling = 'free_counseling',
    general = 'general',
    appointment = 'appointment'
}
